import ReactDOM from "react-dom/client";
import App from "src/App";

const currentUrl = new URL(window.location.href);
let redirectUrl = currentUrl.href;

if (/^\/workspace\/[^/]+\/embed\/?$/i.test(currentUrl.pathname)) {
  const workspace = localStorage.getItem("workspace");
  const group = localStorage.getItem("group");

  redirectUrl = redirectUrl
    .replace(/<%workspace%>|%3C(?:%25|%)workspace(?:%25|%)%3E/gi, (placeholder) => workspace ? encodeURIComponent(workspace) : placeholder)
    .replace(/<%group%>|%3C(?:%25|%)group(?:%25|%)%3E/gi, (placeholder) => group ? encodeURIComponent(group) : placeholder);
}

if (redirectUrl !== currentUrl.href) {
  window.history.replaceState(window.history.state, "", redirectUrl);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
